import _extends from "@babel/runtime/helpers/extends";
export var CLASSIC_BOX_SHADOWS = {
  Shadow_XS: "0px 1px 2px 0px rgba(0, 0, 0, 0.04)",
  Shadow_S: "0px 2px 8px 0px rgba(0, 0, 0, 0.08)",
  Shadow_M: "0px 4px 24px 0px rgba(0, 0, 0, 0.1)",
  Shadow_L: "0px 8px 32px 0px rgba(0, 0, 0, 0.12)",
  // -- legacy

  SMALL: "0px 1px 4px 0px rgba(23, 26, 29, 0.16), 0px 0px 1px 0px rgba(0, 0, 0, 0.16)",
  MEDIUM: "0px 8px 24px 0px rgba(0, 0, 0, 0.16), 0px 0px 1px 0px rgba(0, 0, 0, 0.24)",
  MEDIUM_RAW: "0px 8px 24px 0px rgba(0, 0, 0, 0.16)",
  MEDIUM_ACTIVE: "0px 0px 0px 2px rgba(92, 113, 221, 0.12)",
  LARGE: "0px 12px 32px 0px rgba(0, 0, 0, 0.24), 0px 0px 1px 0px rgba(0, 0, 0, 0.24)"
};
export var MODERN_BOX_SHADOWS = {
  Shadow_XS: "0px 0px 1px 0px rgba(112, 144, 176, 0.24), 0px 2px 8px 0px rgba(112, 144, 176, 0.08)",
  Shadow_S: "0px 0px 1px 0px rgba(112, 144, 176, 0.24), 0px 6px 24px 4px rgba(112, 144, 176, 0.12)",
  Shadow_M: "0px 6px 24px 4px rgba(112, 144, 176, 0.12)",
  Shadow_L: "0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 8px 24px 0px rgba(53, 64, 90, 0.12)",
  // -- legacy

  SMALL: "0px 0px 1px 0px rgba(112, 144, 176, 0.24), 0px 2px 8px 0px rgba(112, 144, 176, 0.08)",
  MEDIUM: "0px 0px 1px 0px rgba(112, 144, 176, 0.24), 0px 6px 24px 4px rgba(112, 144, 176, 0.12)",
  MEDIUM_RAW: "0px 6px 24px 4px rgba(112, 144, 176, 0.12)",
  MEDIUM_ACTIVE: "0px 0px 0px 2px rgba(92, 113, 221, 0.12)",
  LARGE: "0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 8px 24px 0px rgba(53, 64, 90, 0.12)"
};
var loop = fn => {
  Object.keys(CLASSIC_BOX_SHADOWS).map(k => fn(k, "--wdn_10_" + k.toLocaleLowerCase() + "_box_shadow"));
  Object.keys(CLASSIC_BOX_SHADOWS).map(k => fn(k, "--wdn_" + k.toLocaleLowerCase() + "_box_shadow"));
};
export var CLASSIC_BOX_SHADOW_VARS = [];
export var MODERN_BOX_SHADOW_VARS = [];
export var BOX_SHADOWS = _extends({}, CLASSIC_BOX_SHADOWS);
loop((name, varName) => CLASSIC_BOX_SHADOW_VARS.push([varName, CLASSIC_BOX_SHADOWS[name]]));
loop((name, varName) => MODERN_BOX_SHADOW_VARS.push([varName, MODERN_BOX_SHADOWS[name]]));
loop((name, varName) => BOX_SHADOWS[name] = "var(" + varName + ")");
//# sourceMappingURL=box-shadow.js.map